import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import applicationsReducer from "./applicationsReducer";
import authReducer from "./authReducer";
import orgReducer from "./orgReducer";
import usersReducer from "./usersReducer";
import themeReducer from "./themeReducer";
import editorReducer from "./editorReducer";

const uiReducer = combineReducers({
  errors: errorReducer,
  applications: applicationsReducer,
  auth: authReducer,
  orgs: orgReducer,
  users: usersReducer,
  theme: themeReducer,
  editor: editorReducer,
});
export default uiReducer;
